import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-rank',
  },
  {
    name: 'Album',
    key: 'album',
    size: 'large',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-contentId',
  },
  {
    name: 'Passengers',
    key: 'passengers',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengerPoolPer',
  },
];

const data = [
  {
    rank: '1',
    album: 'Kanye West - Bully',
    passengers: {
      display: '29,550',
      sort: 29550,
    },
    passenger_pool_per: '5.91%',
  },
  {
    rank: '2',
    album: 'Don Toliver - Octane',
    passengers: {
      display: '28,311',
      sort: 28311,
    },
    passenger_pool_per: '5.66%',
  },
  {
    rank: '3',
    album: 'BTS - ARIRANG',
    passengers: {
      display: '24,207',
      sort: 24207,
    },
    passenger_pool_per: '4.84%',
  },
  {
    rank: '4',
    album: "Morgan Wallen - I'm The Problem",
    passengers: {
      display: '22,398',
      sort: 22398,
    },
    passenger_pool_per: '4.50%',
  },
  {
    rank: '5',
    album: 'Ella Langley - Dandelion',
    passengers: {
      display: '22,158',
      sort: 22158,
    },
    passenger_pool_per: '4.41%',
  },
];

const AudioAlbums = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.album.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-AudioAlbums-Header" className="title_1">
            Audio albums
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AudioAlbums;
